import axios from 'axios';
import api from '@/services/api'

// Memoized across the app's lifetime: the session cookie is HTTP-only, so the
// only way to know if a page load is still authenticated is to ask the
// server once via /app-init, then reuse that same in-flight/settled promise.
let authReadyPromise = null;
export function ensureAuthReady(dispatch) {
    if (!authReadyPromise) {
        authReadyPromise = dispatch('getTokenStatus');
    }
    return authReadyPromise;
}

const state = {
    authenticated: false,
    user:"",
    loginSource:"login-btn",
    appTokenStatus: false,
}
const getters = {
    authenticated: state => state.authenticated,
    user: state => state.user,
    loginSource: state => state.loginSource,
    appTokenStatus: state => state.appTokenStatus,
}
const mutations = {
    setAuthentication(state, status) {
        state.authenticated = status;
    },
    setUserData(state, data) {
        state.user = data;
    },
    setLoginSource(state, source) {
        state.loginSource = source;
    },
    setTokenStatus(state, source) {
        state.appTokenStatus = source;
    },
}
const actions = {
    // Asks the server whether the (HTTP-only, not client-readable) session
    // cookie is still valid. Used both for the /app-init ping and to
    // rehydrate `authenticated`/`user` on a fresh page load.
    getTokenStatus({ commit }) {
        return axios.get(api.getUrl('/app-init')).then((response) => {
            commit('setTokenStatus', response.data.success);
            commit('setAuthentication', response.data.success === true);
            if (response.data.success && response.data.user) {
                commit('setUserData', response.data.user);
            }
            return response.data.success === true;
        }).catch(() => {
            commit('setTokenStatus', false);
            commit('setAuthentication', false);
            return false;
        });
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}